import React from 'react';
import PropTypes from 'prop-types';
import { intlShape } from '../../../util/reactIntl';
import css from './Sections.module.css';
import { Icons, SecondaryButton } from '../../../components';
import sellersImg from '../../../assets/marketplace-img.png';

function SectionBestMarketplace(props) {
  const { intl } = props;
  return (
    <div className={css.marketplaceContainer}>
      <div className={css.fixedWidthContainer}>
        <div className={css.sellersContent}>
          <div className={css.sellersInfo}>
            <div className={css.sellersInfoInner}>
              <h2>{intl.formatMessage({ id: 'HowItWorksPage.SectionBestMarketplace.title' })}</h2>
              <p>{intl.formatMessage({ id: 'HowItWorksPage.SectionBestMarketplace.description1' })}</p>
              <p>{intl.formatMessage({ id: 'HowItWorksPage.SectionBestMarketplace.description2' })}</p>
              <p>{intl.formatMessage({ id: 'HowItWorksPage.SectionBestMarketplace.description3' })}</p>
            </div>
          </div>
          <div className={css.sellersImg}>
            <img src={sellersImg} alt="banner" />
          </div>
        </div>
      </div>
    </div>
  );
}

SectionBestMarketplace.propTypes = {
  intl: intlShape.isRequired,
};

export default SectionBestMarketplace;